import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { modules } from '../data/modules';
export function Modules() {
  return <section className="w-full bg-shell px-5 py-16 sm:px-8 lg:py-24" data-id="element-78" data-mp="1vx2a4apllmr3">
      <div className="mx-auto max-w-5xl" data-id="element-79" data-mp="1vxu5bkfa9igu">
        <SectionHeading overline="El contenido" size="lg" title={<>
              Todo lo que incluye la{' '}
              <span className="italic text-terracotta-500" data-id="element-81" data-mp="146o3mzjwzcpg">guía completa</span>
            </>} data-id="element-80" data-mp="20vvmu0x299q7" />

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-82" data-mp="186ptmbgaehow">
          {modules.map(module => <article key={module.title} className="flex h-full flex-col rounded-3xl border border-gold-200/60 bg-cream p-6" data-id="element-83" data-mp="1d61arlkkfp70">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-sage-100" data-id="element-84" data-mp="1i6go4d4ukwoz">
                <CheckIcon className="h-4 w-4 text-sage-700" aria-hidden="true" data-id="element-85" data-mp="2oky59azir6lr" />
              </span>
              <p className="mt-5 text-[11px] font-semibold uppercase tracking-overline text-gold-600" data-id="element-86" data-mp="2tjj9dlhw6afh">
                {module.title}
              </p>
              <h3 className="mt-2 font-serif text-[1.4rem] leading-tight text-sage-800" data-id="element-87" data-mp="3tz5609dhhdk9">
                {module.body}
              </h3>
            </article>)}
        </div>
      </div>
    </section>;
}